import { useEffect, useState } from 'react'

interface AnimateProps {
  visible?: boolean
  delay?: number
  children: React.ReactNode
  className?: string
  translateY?: number
  onFadeOutComplete?: () => void
}

const fadeOutTimeMs = 300

const Animate: React.FC<AnimateProps> = ({
  visible = true,
  delay = 0,
  children,
  className,
  translateY = 20,
  onFadeOutComplete
}) => {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    if (!onFadeOutComplete && visible) {
      const fadeInTimer = setTimeout(() => {
        setIsMounted(true)
      }, delay)

      return () => clearTimeout(fadeInTimer)
    } else setIsMounted(true)
  }, [delay, visible, onFadeOutComplete])

  useEffect(() => {
    if (!visible) {
      const fadeOutTimer = setTimeout(() => {
        setIsMounted(false)
        onFadeOutComplete?.()
      }, fadeOutTimeMs)

      return () => clearTimeout(fadeOutTimer)
    }
  }, [visible, onFadeOutComplete])

  return !visible ? null : (
    <div
      className={className}
      style={{
        opacity: isMounted ? 1 : 0,
        transform: isMounted ? 'translateY(0)' : `translateY(${translateY}px)`,
        transition:
          (onFadeOutComplete && !isMounted) || !onFadeOutComplete
            ? `opacity ${fadeOutTimeMs}ms ease, transform 0.5s ease`
            : '',
        cursor: 'pointer',
        pointerEvents: isMounted ? 'auto' : 'none' // Prevent interactions when not visible
      }}
    >
      {children}
    </div>
  )
}

export default Animate
